<template>
  <div v-if="appConfig">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div
          @click="loadAddBalance"
          class="balanceContainer"
          v-on="on"
          :style="{borderColor: balanceAlert}">
          <span :style="{color: balanceAlert}">{{ formatCurrency(balanceComputed, 'USD') }}</span>
        </div>
      </template>
      <span>{{ $t('goToBilling')}}</span>
    </v-tooltip>
    <AddCreditCardDialog
      v-model="creditCardDialog"
      :upgrade="shouldUpgrade"
      @input="creditCardDialog=$event"
      @finishUpgrade="onFinishUpgrade"
      @success="openSuccessDialog"
      @error="openErrorDialog"/>
    <SuccessDialog v-model="successDialog"
                   @input="successDialog=$event"/>
    <ErrorDialog v-model="errorDialog"
                 @input="errorDialog=$event"/>
    <FinishUpgradeDialog v-model="finishUpgradeDialog"
                         @input="finishUpgradeDialog=$event"/>
    <!--Show dialog when balance is 0-->
    <v-dialog v-model="dialog"
              persistent
              max-width="800px">
      <div class="modal-container">
        <img loading="lazy"
             src="https://storage.googleapis.com/keybe/files/bluebird/billing/credit-card.svg"
             alt="credit card"
             class="mb-8">
        <strong>¡Llegaste al límite de tu crédito!</strong>
        <span class="text-center">Estas en el Plan Essential recarga o pasate al Plan Pro para seguir obteniendo los beneficios de keybe.</span>
        <div class="flex justify-space-around px-16 w-full mt-8">
          <v-btn color="#40a9f2"
                 elevation="0"
                 dark
                 rounded
                 large
                 @click="dialog = false; creditCardDialog=true">
            Quiero recargar
          </v-btn>
          <v-btn color="#40a9f2"
                 elevation="0"
                 dark
                 rounded
                 large
                 @click="upgrade">
            Quiero ser Pro
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <add-balance-dialog v-model="balanceDialog"
                        @input="dialog = $event"/>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import BillingService from '@/components/configuration/Services/BillingService'
import BillingValidations from '@/components/configuration/Billing/BillingValidations'
import { EventBus } from '@/eventBus'

import AddCreditCardDialog from '@/components/Dialogs/CreditCard/AddCreditCardDialog'
import SuccessDialog from '@/components/Dialogs/CreditCard/SuccessDialog'
import ErrorDialog from '@/components/Dialogs/CreditCard/ErrorDialog'
import FinishUpgradeDialog from '@/components/Dialogs/CreditCard/FinishUpgradeDialog'
import AddBalanceDialog from '@/components/Dialogs/AddBalance/AddBalance.vue'
import { KeybeIconType } from '@/shared/infrastructure/enums/icons/KeybeIconType'

export default {
  name: 'AccountStatus',
  components: {
    SuccessDialog,
    AddCreditCardDialog,
    ErrorDialog,
    FinishUpgradeDialog,
    AddBalanceDialog
  },
  data () {
    return {
      balance: null,
      dialog: false,
      balanceDialog: false,
      creditCardDialog: false,
      successDialog: false,
      errorDialog: false,
      shouldUpgrade: false,
      finishUpgradeDialog: false,
      windowWidth: window.innerWidth,
      KeybeIconType
    }
  },
  computed: {
    ...mapState('AppStore', ['selectedApp']),
    ...mapState('CompanyStore', ['selectedCompany']),
    ...mapState('UserStore', ['v4Token', 'token']),
    ...mapState('BillingStore', ['appConfig']),
    ...mapGetters('UserStore', ['isAdminOrAbove']),
    hasBalance () {
      return BillingValidations.isEssential() || BillingValidations.hasBalanceProfessional()
    },
    balanceAlert () {
      if (this.appConfig?.balanceUSD > 30) return '#00ffdc'
      if (this.appConfig?.balanceUSD > 20) return '#E1AC00'
      return '#F7685B'
    },
    balanceComputed () {
      let value = this.appConfig.balanceUSD
      if (value) value = this.appConfig.balanceUSD
      return value
    },
    creditComputed () {
      return !!this.appConfig?.hasCredit
    }
  },
  methods: {
    ...mapActions('BillingStore', ['setAppConfig']),
    onFinishUpgrade () {
      this.finishUpgradeDialog = true
      this.balanceDialog = false
    },
    loadAddBalance () {
      // this.balanceDialog = true
      // if (this.appConfig?.balanceUSD <= 0) {
      //   EventBus.$emit('Consumptions-no-balance', true)
      // } else {
      //   EventBus.$emit('Consumptions-add-balance', true)
      if (this.isAdminOrAbove) {
        const token = this.token
        const app = this.selectedApp.uuid
        const url = `${process.env.VUE_APP_BILLING_APP}?token=${token}&app=${app}&section=recharge`
        window.open(url, '_blank')
      }
    },
    openSuccessDialog () {
      this.successDialog = true
      EventBus.$emit('billing:update-credit-card', true)
    },
    openErrorDialog () {
      this.errorDialog = true
      EventBus.$emit('billing:update-credit-card', true)
    },
    openCreditCardDialog () {
      this.dialog = false
      this.creditCardDialog = true
    },
    upgrade () {
      this.shouldUpgrade = true
      this.openCreditCardDialog()
    },
    addCreditCard () {
      this.shouldUpgrade = false
      this.openCreditCardDialog()
    },
    async updateBillingInfo () {
      const appConfig = await BillingService.getAppConfig()
      this.setAppConfig(appConfig)
    },
    formatCurrency (value, currency) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency
      })

      const valueParsed = formatter.format(value)
      const indexOfDecimal = valueParsed.indexOf(formatter.formatToParts(1).find(part => part.type === 'decimal').value)

      return indexOfDecimal !== -1 ? valueParsed.substring(0, indexOfDecimal) : valueParsed
    },
    handleResize () {
      this.windowWidth = window.innerWidth
    }
  },
  async mounted () {
    this.updateBillingInfo()
    // FIX: estandarizar con el area de uso billing:update-balance
    EventBus.$on('upgrade-to-pro', (mode) => {
      if (!mode) return this.upgrade()
      this.addCreditCard()
    })
    EventBus.$on('billing:update-balance', () => {
      this.updateBillingInfo()
    })
    EventBus.$on('billing:add-balance-dialog', (mode) => {
      this.balanceDialog = mode
    })
    window.addEventListener('resize', this.handleResize)
    this.updateFormattedValue()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    balance (val) {
      this.dialog = val === 0
    },
    selectedCompany () {
      if (this.selectedCompany?.uuid) {
        this.updateBillingInfo()
      }
    },
    windowWidth (_) {
      this.updateFormattedValue()
    }
  }
}
</script>

<style scoped lang="scss">
.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  padding: 4rem
}

.balanceContainer {
  cursor: pointer;
  transition: all 0.3s ease;
  color: $morning-coffee;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 100%;
  border-radius: 20px;
  padding: 0 10px;
  border: 1px solid;
  span {
    font-size: 14px !important;
    font-weight: 500;
    line-height: normal !important;
  }
}
</style>
